import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  inject,
  signal,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { BouncedEmailModalData } from 'src/app/shared/Models/dashboard';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'bounced-email-modal',
  templateUrl: './bounced-email-modal.component.html',
  styleUrls: ['./bounced-email-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatDialogClose,
    MatIconModule,
    TranslocoPipe,
  ],
})
export class BouncedEmailModalComponent implements OnDestroy {
  data = inject<BouncedEmailModalData>(MAT_DIALOG_DATA);

  emailClassesLarge = 'mat-mdc-display-2';
  emailClassesSmall = 'mat-mdc-display-1 small';
  readonly emailClasses = signal(this.emailClassesSmall);
  textClassesLarge = 'mat-mdc-h2';
  textClassesSmall = 'mat-mdc-body-1 small';
  readonly textClasses = signal(this.textClassesSmall);
  private destroyed$ = new Subject<void>();

  constructor() {
    const breakpointObserver = inject(BreakpointObserver);

    breakpointObserver
      .observe([Breakpoints.Large, Breakpoints.Medium, Breakpoints.Small])
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        ({
          breakpoints: {
            [Breakpoints.Small]: small,
            [Breakpoints.Medium]: medium,
            [Breakpoints.Large]: large,
          },
        }) => {
          if (small) {
            this.textClasses.set(this.textClassesSmall);
            this.emailClasses.set(this.emailClassesSmall);
          } else if (medium || large) {
            this.textClasses.set(this.textClassesLarge);
            this.emailClasses.set(this.emailClassesLarge);
          }
        },
      );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
